import React from 'react';
import PropTypes from 'prop-types';
import Classes from '../Classes';
import { FavouriteConstants } from '../Constants';

const { favouriteIconUnSelectedPath2 } = FavouriteConstants.favouriteIconUnSelectedPath2;

const FavouriteIcon = ({ isFavourited, iconName, altSVG }) => (
  <svg
    width="21px"
    height="25px"
    viewBox="0 0 25 23"
    aria-labelledby="uniqueDescID"
    role="img"
    className={Classes.favIcon}
  >
    <desc id="uniqueDescID">{altSVG}</desc>
    {isFavourited ?
      <g transform="translate(-1470.000000, -489.000000)">
        <path className={Classes.favSelectFill} d={iconName} />
      </g>
            :
      <g>
        <path className={Classes.favSelectFill} d={iconName} />
        <path className={Classes.favUnselectFill} d={favouriteIconUnSelectedPath2} />
      </g>
        }
  </svg>);

FavouriteIcon.propTypes = {
  isFavourited: PropTypes.bool.isRequired,
  iconName: PropTypes.string.isRequired,
  altSVG: PropTypes.string.isRequired
};

export default FavouriteIcon;
